var _path, _path2, _path3, _path4, _path5, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSecurePayments(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30C60 46.5685 46.5685 60 30 60C13.4315 60 0 46.5685 0 30Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 0.5C46.2924 0.5 59.5 13.7076 59.5 30C59.5 46.2924 46.2924 59.5 30 59.5C13.7076 59.5 0.5 46.2924 0.5 30C0.5 13.7076 13.7076 0.5 30 0.5Z",
    stroke: "url(#paint0_linear_18_2550)",
    strokeOpacity: 0.41
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14258 30.0001C5.14258 16.2719 16.2715 5.14294 29.9997 5.14294C43.7279 5.14294 54.8569 16.2719 54.8569 30.0001C54.8569 43.7283 43.7279 54.8572 29.9997 54.8572C16.2715 54.8572 5.14258 43.7283 5.14258 30.0001Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 5.64294C43.4519 5.6431 54.3564 16.5484 54.3564 30.0004C54.3563 43.4522 43.4519 54.3567 30 54.3568C16.548 54.3568 5.64273 43.4523 5.64258 30.0004C5.64258 16.5483 16.5479 5.64294 30 5.64294Z",
    stroke: "url(#paint1_linear_18_2550)",
    strokeOpacity: 0.41
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_2550)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_2550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 15,
    width: 30,
    height: 30
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 15.0001H15V45.0001H45V15.0001Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_2550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.8627 31.7249H28.7502C28.3752 31.7249 28.0752 32.0249 28.0752 32.3999C28.0752 32.7749 28.3752 33.0749 28.7502 33.0749H31.8627C32.2377 33.0749 32.5377 32.7749 32.5377 32.3999C32.5377 32.0249 32.2377 31.7249 31.8627 31.7249Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8 31.7249H25.2375C24.8625 31.7249 24.5625 32.0249 24.5625 32.3999C24.5625 32.7749 24.8625 33.0749 25.2375 33.0749H26.8C27.175 33.0749 27.475 32.7749 27.475 32.3999C27.475 32.0249 27.175 31.7249 26.8 31.7249Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1749 20.2756L31.2999 17.7006C30.5874 17.4381 29.4249 17.4381 28.7124 17.7006L21.8375 20.2756C20.5125 20.7756 19.4375 22.3256 19.4375 23.7381V33.8631C19.4375 34.8756 20.1 36.2131 20.9125 36.8131L27.7874 41.9506C28.9999 42.8631 30.9874 42.8631 32.1999 41.9506L39.0749 36.8131C39.8874 36.2006 40.5501 34.8756 40.5501 33.8631V23.7381C40.5626 22.3256 39.4874 20.7756 38.1749 20.2756ZM37.7124 32.0631C37.6874 34.6506 36.9749 35.3006 34.2874 35.3006H25.725C22.9875 35.3006 22.3 34.6256 22.3 31.9131V29.0006C22.3 28.6506 22.575 28.3756 22.925 28.3756H37.0874C37.4374 28.3756 37.7124 28.6506 37.7124 29.0006V32.0631ZM37.7124 26.3881C37.7124 26.7381 37.4374 27.0131 37.0874 27.0131H22.925C22.575 27.0131 22.3 26.7381 22.3 26.3881V25.5881C22.3 23.1381 22.875 22.3506 25.0125 22.2131C25.2375 22.2131 25.475 22.2006 25.725 22.2006H34.2874C37.0249 22.2006 37.7124 22.8756 37.7124 25.5881V26.3881Z",
    fill: "#34D399"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_2550",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_2550",
    x1: 29.9997,
    y1: 5.14294,
    x2: 29.9997,
    y2: 54.8572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_2550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(15 15.0001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecurePayments);
export default __webpack_public_path__ + "static/media/icon-secure-payments.b086abdae8c60263b28fc8bad8c8e799.svg";
export { ForwardRef as ReactComponent };